import React from 'react';
import styled from 'styled-components';
import Footer from './Footer';

interface GradientLayoutProps {
  children: React.ReactNode;
  withFooter?: boolean;
  background?: string;
}

const Wrapper = styled.div<{ background: string }>`
  min-height: 100dvh;
  background: ${({ background }) => background};
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const GradientLayout: React.FC<GradientLayoutProps> = ({
  children,
  withFooter = true,
  background = 'linear-gradient(180deg, #a64cf2 0%, #6b1fa4 100%)',
}) => {
  return (
    <Wrapper background={background}>
      <Content>{children}</Content>
      {withFooter && <Footer />}
    </Wrapper>
  );
};

export default GradientLayout;
